module.exports = __webpack_public_path__ + "img/cross.f0969638.svg";